<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11 2C12.6569 2 14 3.34315 14 5L14.0001 6.17067C14.3128 6.06014 14.6494 6 15 6H19C20.6569 6 22 7.34315 22 9V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H11ZM11 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H12V5C12 4.44772 11.5523 4 11 4ZM19 8H15C14.4477 8 14 8.44772 14 9V20H19C19.5523 20 20 19.5523 20 19V9C20 8.44772 19.5523 8 19 8ZM9 14C9.55228 14 10 14.4477 10 15C10 15.5523 9.55228 16 9 16H7C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14H9ZM18 14C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16H16C15.4477 16 15 15.5523 15 15C15 14.4477 15.4477 14 16 14H18ZM9 10C9.55228 10 10 10.4477 10 11C10 11.5523 9.55228 12 9 12H7C6.44772 12 6 11.5523 6 11C6 10.4477 6.44772 10 7 10H9ZM18 10C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H16C15.4477 12 15 11.5523 15 11C15 10.4477 15.4477 10 16 10H18ZM9 6C9.55228 6 10 6.44772 10 7C10 7.55228 9.55228 8 9 8H7C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6H9Z"
    fill="currentColor"
  />
</svg>
